<script setup>
import { Modal } from 'bootstrap';
import { useToast } from '~/composables/useToast';
import { useClientsStore } from '~/stores/clients';

const modalChangeCompany = ref(null);
const modalElement = ref(null);
const { t } = useI18n();
const clientsStore = useClientsStore();
const toast = useToast();

// Track modal state for safety
const modalOpenTime = ref(null);
let safetyTimeout = null;

function doAction(status) {
  if (!modalChangeCompany.value) {
    const divElementModalChangeCompany = modalElement.value;

    if (!divElementModalChangeCompany) {
      //clientsStore.updateVisibility(false);
      return;
    }

    modalChangeCompany.value = new Modal(divElementModalChangeCompany, {
      keyboard: false,
      backdrop: 'static',
      focus: true,
    });

    // Ensure state synchronization when modal is hidden
    divElementModalChangeCompany.addEventListener('hidden.bs.modal', () => {
      if (clientsStore.visibilityModalChangeClient) {
        //clientsStore.updateVisibility(false);
      }
    });
  }

  if (safetyTimeout) {
    clearTimeout(safetyTimeout);
    safetyTimeout = null;
  }

  if (status) {
    modalOpenTime.value = Date.now();
    modalChangeCompany.value.show();

    // Safety mechanism to prevent stuck modals
    safetyTimeout = setTimeout(() => {
      if (clientsStore.visibilityModalChangeClient) {
        toast.warning(
          t('client.company_switch.modal_stuck_title'),
          t('client.company_switch.modal_stuck_message')
        );
        //clientsStore.updateVisibility(false);
        modalChangeCompany.value.hide();
      }
    }, 30000);
  } else {
    clientsStore.resetDashboardGraphs();
    modalOpenTime.value = null;

    try {
      modalChangeCompany.value.hide();
    } catch {
      // Fallback approach if Bootstrap modal fails
      if (modalElement.value) {
        modalElement.value.classList.remove('show');
        document.body.classList.remove('modal-open');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.parentNode.removeChild(backdrop);
        }
      }
    }
  }
}

// Watch store property to respond to visibility changes
watch(
  () => clientsStore.visibilityModalChangeClient,
  status => {
    doAction(status);
  }
);

// Clean up on component unmount
onBeforeUnmount(() => {
  if (safetyTimeout) {
    clearTimeout(safetyTimeout);
  }

  if (modalOpenTime.value !== null) {
    try {
      modalChangeCompany.value?.hide();
      document.body.classList.remove('modal-open');
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }
    } catch {
      // Silent fallback
    }
  }
});
</script>

<template>
  <div
    id="modalChangeCompany"
    ref="modalElement"
    role="dialog"
    aria-labelledby="modalChangeCompanyLabel"
    class="modal fade"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body text-center" role="document">
          <div class="spinner-border mb-3" role="status">
            <span class="visually-hidden">{{ $t('common.loading') }}</span>
          </div>

          <h3 id="modalChangeCompanyLabel">
            {{ t('dashboard.switch_company.title') }}
          </h3>
          <p class="text-muted m-0">
            {{ t('dashboard.switch_company.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
